import { tv } from "../../variants/tv.js";
const toolbarVariants = tv({
    slots: {
        root: 'flex items-center gap-1 bg-none p-2',
        buttonLeftSlot: 'flex shrink-0 items-center self-stretch',
        itinerarySlot: 'flex min-w-0 flex-1 flex-col items-start gap-2 px-1',
        buttonRightSlot: 'flex shrink-0 items-center self-stretch'
    },
    variants: {
        condensed: {
            true: '',
            false: ''
        },
        emphasis: {
            regular: {
                root: 'bg-primary-1/90'
            },
            medium: {
                root: 'bg-primary-8'
            },
            bold: {
                root: 'p-0'
            }
        },
        animate: {
            true: '',
            false: ''
        }
    },
    defaultVariants: {
        condensed: false,
        emphasis: 'medium',
        animate: false
    }
});
const toolbarVariantKeys = Object.keys(toolbarVariants.variants);
export { toolbarVariantKeys, toolbarVariants };
